<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import OrderBumpPrice from '../components/order_bump_price';

export default {
  components: {
    OrderBumpPrice
  },

  data() {
    return {
      checkboxName: 'order_bump_selected'
    };
  },

  computed: {
    ...mapState([
      'orderBump',
    ]),

    checked: {
      get() {
        return this.orderBump.checked;
      },

      set(value) {
        this.setOrderBumpChecked({
          checked: value
        });
        this.updateAmounts();
      }
    },

    productLogoChoice() {
      return this.orderBump.logoChoice === 'product';
    },

    focusedOrderBumpPrices() {
      return JSON.parse(this.orderBump.focusedAmounts);
    },

    unFocusedOrderBumpPrices() {
      return JSON.parse(this.orderBump.unFocusedAmounts);
    },

    focusOnPriceExVat() {
      return this.orderBump.focusOnPriceExVat;
    }
  },

  methods: {
    ...mapActions([
      'updateAmounts'
    ]),

    ...mapMutations([
      'setOrderBumpChecked'
    ]),

    vatText() {
      if (this.focusOnPriceExVat) return this.t('pay.js.marketing.summary.inc_vat');
      return this.t('pay.js.marketing.summary.ex_vat');
    }
  }
};
</script>

<template>
  <div class="c-order-bump mt-4">
    <div class="row g-0 align-items-center p-4">
      <div class="col-12 text-break">
        <div class="c-form__checkbox c-form__checkbox--bold">
          <input
            :id="checkboxName"
            v-model="checked"
            :name="checkboxName"
            value="on"
            type="checkbox"
          >

          <div class="c-form__checkbox__checkmark" />

          <label
            :for="checkboxName"
            class="ps-4"
          >
            <span>{{ orderBump.name }}</span>
          </label>
        </div>
      </div>

      <div class="col-8 text-break">
        <p class="c-order-bump__desc mt-3">
          {{ orderBump.description }}
        </p>

        <div class="mt-3">
          <span class="price">
            <order-bump-price
              :amount-from="focusedOrderBumpPrices.original_amount"
              :amount-to="focusedOrderBumpPrices.current_amount"
            />
          </span>
          <small class="d-block c-order-bump__desc">
            <order-bump-price
              :amount-from="unFocusedOrderBumpPrices.original_amount"
              :amount-to="unFocusedOrderBumpPrices.current_amount"
            />
            ({{ vatText() }})
          </small>
        </div>
      </div>

      <div class="col-4 d-flex align-items-center justify-content-end">
        <img
          v-if="productLogoChoice"
          :src="orderBump.imageUrl"
          :alt="orderBump.name"
          class="c-order-bump__logo"
        >
      </div>
    </div>
  </div>
</template>
